import React, { Component } from 'react';
import { observer } from "mobx-react";
import { makeObservable, observable, action } from 'mobx';
import StatsStore from 'Stores/Stats/StatsStore';
import 'Styles/Stats.scss';
import 'Styles/commonComponents/SmrTable.scss';
import 'Styles/commonComponents/Table/Table.scss';
import StatFilters from 'Components/Stats/StatFilters';
import FiltersStore from 'Stores/Stats/FiltersStore';
import 'Styles/Metrics.scss';
import DocumentInfoModal from 'Components/Stats/DocumentInfoModal';
import GraphBar from 'Components/Stats/GraphBar';
import AppStore from 'Stores/AppStore';
import Helper from "Utils/Helper";
import { ShowModal, CloseModal } from 'Utils/CommonFunctions';
import { Link } from 'react-router-dom';
import Sorting from "Utils/Sorting";
import Enumerable from "linq";
import { WebMetricDateRangePeriodType } from "Stores/models/Enums";
import LoadView from "Components/Common/loadView";
import ShowFiltersButton from "Components/Common/FiltersPanel/ShowFiltersButton";

class Stats extends Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        AppStore.OnMainComponentMount('Статистика', 'stats');

        FiltersStore.GetInitData(() => StatsStore.GetData());
    }

    onResize = action(() => {
        if (this.mainNode) {
            StatsStore.graphsWidth = this.mainNode.clientWidth - 20/* scroll */;
        }
    });

    GetDateString(date) {
        return Helper.DateFormatDDMMYYYY(date);
    }

    GetCellTextOfSingleUser(userDlInfos) {
        let userDlMainFirst = userDlInfos.find(it => it.isMain == true);
        if (userDlMainFirst == null)
            return "";
        let userDlMainFirstAdditionalDls = userDlInfos.filter(it => it.isMain == false && it.userLid == userDlMainFirst.userLid);
        return `${userDlMainFirst.contactName} - ${userDlMainFirst.contactPost}` + (userDlMainFirstAdditionalDls.length == 0 ? "" : ` (+${userDlMainFirstAdditionalDls.length} ДОП. ДЛ)`);
    }

    GetCellTextOfMultipleUsers(userDlInfos) {
        let userDlsMain = userDlInfos.filter(it => it.isMain == true);
        let userDlMainFirst = userDlsMain.find(it => it);
        if (userDlMainFirst == null)
            return "";
        return `${userDlMainFirst.contactName} - ${userDlMainFirst.contactPost}` + (userDlsMain.length <= 1 ? "" : ` (+${userDlsMain.length - 1})`);
    }

    GetAdditionalInfoButton(dataItem) {
        return dataItem.regNum
            ? (
                <button
                    className={(dataItem.userDlInfos?.length > 0 == true || dataItem.documentFileInfos?.length > 0 == true) ? "" : "disabled"}
                    onClick={() => ShowModal({
                        canBeClosed: true,
                        header: dataItem.regNum ? `Информация по документу: Рег. № ${dataItem.regNum} от ${Helper.DateFormatDDMMYYYY(dataItem.regDate)}` : "",
                        children: (<DocumentInfoModal dataItem={dataItem} />),
                        width: "90%",
                        height: "90%"
                    })}
                >
                    ПОДРОБНЕЕ
                </button>
            )
            : null
            ;
    }

    GetSortOrderIcon(sectionName, fieldName) {
        return Sorting.GetSortOrderIcon((FiltersStore.sort[sectionName] == null || FiltersStore.sort[sectionName].fieldName != fieldName) ? null : FiltersStore.sort[sectionName].isDesc);
    }

    SetSortOrderNext(sectionName, fieldName) {
        let sortRule = FiltersStore.sort[sectionName];
        let isDescNew = (sortRule == null || sortRule.fieldName != fieldName) ? false : (sortRule.isDesc == false);
        FiltersStore.sort[sectionName] =
        {
            fieldName: fieldName,
            isDesc: isDescNew
        };
    }

    GetSortedData(sectionName, columnInfos) {
        let rows = StatsStore.data[sectionName];
        let tmpSortInfo = FiltersStore.sort[sectionName];
        if (tmpSortInfo == null)
            return rows;

        let fieldName = tmpSortInfo.fieldName;
        let isDesc = tmpSortInfo.isDesc;
        let columnInfo = columnInfos.find(it => it.columnName == fieldName)
        let rowsEnumerable = Enumerable.from(rows);
        let getColumnValue = dataItem =>
            columnInfo.getColumnValue
                ? columnInfo.getColumnValue(dataItem)
                : dataItem[columnInfo.columnName]
            ;
        let rowsEnumerableSorted =
            isDesc
                ? rowsEnumerable.orderByDescending(getColumnValue)
                : rowsEnumerable.orderBy(getColumnValue)
            ;
        let ret = rowsEnumerableSorted.toArray();
        return ret;
    }

    GetSectionHtml(sectionName, columnInfos) {
        return StatsStore.data?.[sectionName] == null ? "" : (
            <div className="Table smr-border">
                <div className="header-row">
                    {columnInfos.map(columnInfo => (
                        <div
                            className={columnInfo.columnName == null ? null : `${columnInfo.columnName}-column ${columnInfo.columnName}-column-width ${columnInfo.sortable == false ? "" : "table-column-content-sortable sortable"}`}
                            style={{ width: columnInfo.widthStr }}
                            onClick={(columnInfo.columnName == null || columnInfo.sortable == false) ? null : (() => this.SetSortOrderNext(sectionName, columnInfo.columnName))}
                        >
                            {columnInfo.text} {(columnInfo.text == null || columnInfo.sortable == false) ? null : this.GetSortOrderIcon(sectionName, columnInfo.columnName)}
                        </div>
                    ))}
                </div>
                <div>
                    {StatsStore.data[sectionName].length == 0
                        ? (
                            <div className="row-no-data">Записи отсутствуют</div>
                        )
                        : (
                            this.GetSortedData(sectionName, columnInfos).map(dataItem =>
                                <div
                                    key={dataItem.userId}
                                    className='row'
                                >
                                    {columnInfos.map(columnInfo => (
                                        <div
                                            style={{ width: columnInfo.widthStr }}
                                            className={`${(columnInfo.isAdditionalInfoButton ? "row-button" : "")}`}
                                        >
                                            {(
                                                columnInfo.isAdditionalInfoButton
                                                    ? this.GetAdditionalInfoButton(dataItem)
                                                    : columnInfo.getColumnValue
                                                        ? columnInfo.getColumnValue(dataItem)
                                                        : dataItem[columnInfo.columnName]
                                            )}
                                        </div>
                                    ))}
                                </div>
                            )
                        )}
                </div>
            </div>
        );
    }

    GetDateRangeDescription(isSectionFilesConvertInfo) {
        let daysDiff = Helper.DatesDiffDays(StatsStore.data.dateTo, StatsStore.data.dateFrom);
        let tableDateRangeDescriptionText =
            (FiltersStore.filters.dateRangePeriodType == WebMetricDateRangePeriodType.current && isSectionFilesConvertInfo != true)
                ? `Данные на ${Helper.DateTimeFormatDDMMYYYYHHmmss(StatsStore.data.dateTo)}`
                : daysDiff <= 1
                    ? `Данные за период ${Helper.DateFormatDDMMYYYY(StatsStore.data.dateFrom)} c ${Helper.DateTimeFormatHHmmss(StatsStore.data.dateFrom)} по ${Helper.DateTimeFormatHHmmss(StatsStore.data.dateTo)}`
                    : `Данные за период с ${Helper.DateTimeFormatDDMMYYYYHHmmss(StatsStore.data.dateFrom)} по ${Helper.DateTimeFormatDDMMYYYYHHmmss(StatsStore.data.dateTo)}`
            ;
        return tableDateRangeDescriptionText;
    }

    render() {
        if (StatsStore.dataLoading)
            return (
                <LoadView loading={true} />
            );

        // StatsStore.dataLoading через style display, чтобы не заморачиваться с сохранением положения скрола

        let tableDateRangeDescription = (<div className="Stats-table-date-range-description">{this.GetDateRangeDescription(false)}</div>);
        let tableDateRangeDescriptionSectionFilesConvertInfo = (<div className="Stats-table-date-range-description">{this.GetDateRangeDescription(true)}</div>);
        let graphDateRangeDescription = `с ${Helper.DateFormatDDMMYYYY(StatsStore.data.graphFrom)} по ${Helper.DateFormatDDMMYYYY(StatsStore.data.graphTo)}`;

        return (
            <div className="Stats page-with-scroll-elements">

                <div
                    className="page-with-scroll-elements"
                    ref={node => {
                        this.mainNode = node;
                        if (node) {
                            this.onResize();
                            window.addEventListener('resize', () => this.onResize());
                        }
                    }}
                >

                    <div className="smr-table-row-line-no-data" style={{ display: (StatsStore.dataLoading ? "" : "none") }}>Загружается</div>

                    <div className="scroll" style={{ display: (StatsStore.dataLoading ? "none" : "") }}>
                        <div className="scroll-content-container">

                            <div className="Stats-top-buttons-container" style={{ display: (StatsStore.dataLoading ? "none" : "") }}>
                                <ShowFiltersButton
                                    className={(StatsStore.dataLoading ? ' disabled' : '')}
                                    getFiltersRender={() => FiltersStore.filtersRender}
                                    getFilters={() => FiltersStore.filters}
                                    clearFilters={() => {
                                        FiltersStore.ClearFiltersRender();
                                        FiltersStore.SaveFiltersFromRender();
                                        StatsStore.GetData();
                                    }}
                                    search={() => StatsStore.GetData()}
                                    getSelectedFiltersCount={() => FiltersStore.GetSelectedFiltersCount()}
                                    showFullFilters={() => {
                                        ShowModal({
                                            className: "Metrics-filters-modal",
                                            canBeClosed: true,
                                            header: 'Фильтрация данных',
                                            children: (
                                                <div className="filters-modal-container">
                                                    <StatFilters />
                                                </div>
                                            ),
                                            buttons: [
                                                {
                                                    content: 'Очистить',
                                                    closer: false,
                                                    onClick: _ => FiltersStore.ClearFiltersRender()
                                                },
                                                {
                                                    content: 'Применить',
                                                    className: "blue-button",
                                                    closer: true,
                                                    onClick: _ => {
                                                        FiltersStore.SaveFiltersFromRender();
                                                        StatsStore.GetData();
                                                    }
                                                }]
                                        });
                                    }}
                                />
                                <button onClick={() => StatsStore.GetData()}>
                                    Обновить
                                </button>
                                <button onClick={() => StatsStore.ExportData()}>
                                    Выгрузить данные
                                </button>
                                {FiltersStore.debug != true ? null : (
                                    <button onClick={() => this.htmlElementImportJsonFileInput?.click()}>
                                        Загрузить файл
                                    </button>
                                )}
                                <input
                                    ref={node => this.htmlElementImportJsonFileInput = node}
                                    id='import-json-file-input'
                                    style={{ display: 'none' }}
                                    type="file"
                                    accept=".json"
                                    onChange={e => StatsStore.ImportData(e)} />
                            </div>

                            <div
                                id="sectionUsersCount"
                                className="Stats-table-name-container">
                                Пользователи
                            </div>
                            {tableDateRangeDescription}
                            {
                                this.GetSectionHtml(
                                    "sectionUsersCount",
                                    [
                                        { columnName: "type", text: "Статус", sortable: false, widthStr: "90%" },
                                        { columnName: "count", text: "Количество", sortable: false, widthStr: "10%" }
                                    ]
                                )
                            }
                            <div className="Stats-row-buttons-container">
                                <Link to={`${window.SmrLocation}/usersMetrics`}>
                                    <button>
                                        Список пользователей
                                    </button>
                                </Link>
                            </div>

                            {StatsStore?.data?.graphsSectionsById?.["sectionUsersCount"] == null ? null : (
                                <div className="Stats-table-name-container" >
                                    Пользователи за период {graphDateRangeDescription}
                                </div>
                            )}
                            <GraphBar
                                sectionId="sectionUsersCount"
                            />

                            <div
                                id="sectionUsersDocumentsCount"
                                className="Stats-table-name-container">
                                Пользователи с наибольшим количеством документов
                            </div>
                            {tableDateRangeDescription}
                            {this.GetSectionHtml(
                                "sectionUsersDocumentsCount",
                                [
                                    { columnName: "userDlInfos", getColumnValue: dataItem => this.GetCellTextOfSingleUser(dataItem.userDlInfos), text: "Пользователь", widthStr: "40%" },
                                    { columnName: "documentsCount", text: "Общее количество РК/РКПД", widthStr: "15%" },
                                    { columnName: "documentsCountRk", text: "Количество РК", widthStr: "15%" },
                                    { columnName: "documentsCountRkpd", text: "Количество РКПД", widthStr: "15%" },
                                    { columnName: "userLid", text: "ID пользователя", widthStr: "15%" },

                                ]
                            )}

                            <div
                                id="sectionDocumentsMaxCountLinkedDocuments"
                                className="Stats-table-name-container">
                                Документы с наибольшим количеством связок
                            </div>
                            {tableDateRangeDescription}
                            {this.GetSectionHtml(
                                "sectionDocumentsMaxCountLinkedDocuments",
                                [
                                    { columnName: "regNum", getColumnValue: dataItem => `${dataItem.regNum} от ${this.GetDateString(dataItem.regDate)}`, text: "Рег. №", widthStr: "15%" },
                                    { columnName: "description", text: "Содержание", widthStr: "40%" },
                                    { columnName: "userDlInfos", getColumnValue: dataItem => this.GetCellTextOfMultipleUsers(dataItem.userDlInfos), text: "Пользователь", widthStr: "25%" },
                                    { columnName: "objectsCount", text: "Количество связок", widthStr: "10%" },
                                    { isAdditionalInfoButton: true, widthStr: "10%" }
                                ]
                            )}

                            <div
                                id="sectionDocumentsMaxSizeFiles"
                                className="Stats-table-name-container">
                                Документы с наибольшим суммарным размером файлов
                            </div>
                            {tableDateRangeDescription}
                            {this.GetSectionHtml(
                                "sectionDocumentsMaxSizeFiles",
                                [
                                    { columnName: "regNum", getColumnValue: dataItem => `${dataItem.regNum} от ${this.GetDateString(dataItem.regDate)}`, text: "Рег. №", widthStr: "15%" },
                                    { columnName: "description", text: "Содержание", widthStr: "30%" },
                                    { columnName: "userDlInfos", getColumnValue: dataItem => this.GetCellTextOfMultipleUsers(dataItem.userDlInfos), text: "Пользователь", widthStr: "25%" },
                                    { columnName: "filesSizeSumTypeIsOriginal", getColumnValue: dataItem => StatsStore.GetFileSizeMb(dataItem.filesSizeSumTypeIsOriginal), text: "Размер оригиналов, Мб", widthStr: "10%" },
                                    { columnName: "filesSizeSumTypesAll", getColumnValue: dataItem => StatsStore.GetFileSizeMb(dataItem.filesSizeSumTypesAll), text: "Размер всего, Мб", widthStr: "10%" },
                                    { isAdditionalInfoButton: true, widthStr: "10%" }
                                ]
                            )}

                            <div
                                id="sectionDocumentsMaxCountFiles"
                                className="Stats-table-name-container">
                                Документы с наибольшим количеством файлов
                            </div>
                            {tableDateRangeDescription}
                            {this.GetSectionHtml(
                                "sectionDocumentsMaxCountFiles",
                                [
                                    { columnName: "regNum", getColumnValue: dataItem => `${dataItem.regNum} от ${this.GetDateString(dataItem.regDate)}`, text: "Рег. №", widthStr: "15%" },
                                    { columnName: "description", text: "Содержание", widthStr: "30%" },
                                    { columnName: "userDlInfos", getColumnValue: dataItem => this.GetCellTextOfMultipleUsers(dataItem.userDlInfos), text: "Пользователь", widthStr: "25%" },
                                    { columnName: "filesCountTypeIsOriginal", getColumnValue: dataItem => dataItem.filesCountTypeIsOriginal, text: "Количество файлов (оригиналов)", widthStr: "10%" },
                                    { columnName: "filesCountTypesAll", getColumnValue: dataItem => dataItem.filesCountTypesAll, text: "Всего файлов", widthStr: "10%" },
                                    { isAdditionalInfoButton: true, widthStr: "10%" }
                                ]
                            )}

                            {StatsStore.data?.["sectionFilesConvertInfo"] == null ? null : [
                                (<div
                                    key="sectionFilesConvertInfo"
                                    id="sectionFilesConvertInfo"
                                    className="Stats-table-name-container">
                                    Количество загруженных и преобразованных в PDF файлов
                                </div>),
                                tableDateRangeDescriptionSectionFilesConvertInfo
                            ]}
                            {this.GetSectionHtml(
                                "sectionFilesConvertInfo",
                                [
                                    { columnName: "type", text: "Состояния файлов", sortable: false, widthStr: "90%" },
                                    { columnName: "count", text: "Количество файлов", sortable: false, widthStr: "10%" }
                                ]
                            )}

                            <div
                                id="sectionDocumentsMaxCountResolutions"
                                className="Stats-table-name-container">
                                Документы с наибольшим количеством поручений
                            </div>
                            {tableDateRangeDescription}
                            {this.GetSectionHtml(
                                "sectionDocumentsMaxCountResolutions",
                                [
                                    { columnName: "regNum", getColumnValue: dataItem => `${dataItem.regNum} от ${this.GetDateString(dataItem.regDate)}`, text: "Рег. №", widthStr: "15%" },
                                    { columnName: "description", text: "Содержание", widthStr: "40%" },
                                    { columnName: "userDlInfos", getColumnValue: dataItem => this.GetCellTextOfMultipleUsers(dataItem.userDlInfos), text: "Пользователь", widthStr: "25%" },
                                    { columnName: "objectsCount", text: "Количество поручений", widthStr: "10%" },
                                    { isAdditionalInfoButton: true, widthStr: "10%" }
                                ]
                            )}

                            <div
                                id="sectionDocumentsMaxCountReports"
                                className="Stats-table-name-container">
                                Документы с наибольшим количеством отчетов
                            </div>
                            {tableDateRangeDescription}
                            {this.GetSectionHtml(
                                "sectionDocumentsMaxCountReports",
                                [
                                    { columnName: "regNum", getColumnValue: dataItem => `${dataItem.regNum} от ${this.GetDateString(dataItem.regDate)}`, text: "Рег. №", widthStr: "15%" },
                                    { columnName: "description", text: "Содержание", widthStr: "40%" },
                                    { columnName: "userDlInfos", getColumnValue: dataItem => this.GetCellTextOfMultipleUsers(dataItem.userDlInfos), text: "Пользователь", widthStr: "25%" },
                                    { columnName: "objectsCount", text: "Количество отчетов", widthStr: "10%" },
                                    { isAdditionalInfoButton: true, widthStr: "10%" }
                                ]
                            )}

                            <div
                                id="sectionDocumentsMaxCountVisas"
                                className="Stats-table-name-container">
                                Документы с наибольшим количеством виз
                            </div>
                            {tableDateRangeDescription}
                            {this.GetSectionHtml(
                                "sectionDocumentsMaxCountVisas",
                                [
                                    { columnName: "regNum", getColumnValue: dataItem => `${dataItem.regNum} от ${this.GetDateString(dataItem.regDate)}`, text: "Рег. №", widthStr: "15%" },
                                    { columnName: "description", text: "Содержание", widthStr: "40%" },
                                    { columnName: "userDlInfos", getColumnValue: dataItem => this.GetCellTextOfMultipleUsers(dataItem.userDlInfos), text: "Пользователь", widthStr: "25%" },
                                    { columnName: "objectsCount", text: "Количество виз", widthStr: "10%" },
                                    { isAdditionalInfoButton: true, widthStr: "10%" }
                                ]
                            )}

                            <div
                                id="sectionDocumentsMaxCountSigns"
                                className="Stats-table-name-container">
                                Документы с наибольшим количеством подписей
                            </div>
                            {tableDateRangeDescription}
                            {this.GetSectionHtml(
                                "sectionDocumentsMaxCountSigns",
                                [
                                    { columnName: "regNum", getColumnValue: dataItem => `${dataItem.regNum} от ${this.GetDateString(dataItem.regDate)}`, text: "Рег. №", widthStr: "15%" },
                                    { columnName: "description", text: "Содержание", widthStr: "40%" },
                                    { columnName: "userDlInfos", getColumnValue: dataItem => this.GetCellTextOfMultipleUsers(dataItem.userDlInfos), text: "Пользователь", widthStr: "25%" },
                                    { columnName: "objectsCount", text: "Количество подписей", widthStr: "10%" },
                                    { isAdditionalInfoButton: true, widthStr: "10%" }
                                ]
                            )}

                            <div
                                id="sectionUnprocessedEvents"
                                className="Stats-table-name-container">
                                События синхронизации с СЭД Дело
                            </div>
                            {tableDateRangeDescription}
                            <div className="Table smr-border">
                                <div className="header-row-without-cell-styles">
                                    <div>Параметры обработки</div>
                                    <div>Значение</div>
                                </div >
                                <div>
                                    <div className="row-without-cell-styles">
                                        <div>Количество необработанных событий</div>
                                        <div>{StatsStore.data?.sectionUnprocessedEvents}</div>
                                    </div>
                                    {
                                        FiltersStore.filters.dateRangePeriodType == WebMetricDateRangePeriodType.today
                                            ? (
                                                <div className="row-without-cell-styles">
                                                    <div>Максимальное время неоконченной обработки сообщений</div>
                                                    <div>{StatsStore.data?.sectionLastDownloadedEventInDeloSpanInfo ?? "Событий нет"}
                                                    </div>
                                                </div>
                                            )
                                            : (
                                                <div className="row-without-cell-styles">
                                                    <div>Максимальное время обработки сообщений</div>
                                                    <div>{StatsStore.data?.sectionProcessingEventsMaxSpanInfo ?? "Событий нет"}
                                                    </div>
                                                </div>
                                            )
                                    }
                                </div>
                            </div>
                            <div className="Table smr-border" style={{ marginTop: "20px" }} >
                                <div className="header-row-without-cell-styles">
                                    <div>Очереди ожидания</div>
                                    <div>Количество</div>
                                </div >
                                <div>
                                    <div className="row-without-cell-styles">
                                        <div>События, ожидающие копирования из СЭД в СМР</div>
                                        <div>{StatsStore.data?.sectionNotTRansferedEventsFromDeloToSmrCount ?? "Сервис интеграции не доступен"}
                                        </div>
                                    </div>
                                    <div className="row-without-cell-styles">
                                        <div>События, ожидающие обработки ФЗ СЭД</div>
                                        <div>{StatsStore.data?.sectionNotTransferedEventsFromFzToDeloCount ?? "Сервис интеграции не доступен"}</div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>

            </div>
        );
    }
}

export default observer(Stats);